// extracted by mini-css-extract-plugin
export var container = "_4r-0";
export var disabled = "_4r-4";
export var fullWidth = "_4r-3";
export var lined = "_4r-1";
export var selected = "_4r-5";
export var tab = "_4r-2";